import Router from "vue-router";
import index from "@/view/index.vue";
const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch((err) => {});
};

let routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "/index",
    component: index,
    redirect:"/home",
    children:[
      {
        path:"/home",
        name:"home",
        component:()=>import('@/view/home/home.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/about-us",
        name:"about-us",
        component:()=>import('@/view/about/about.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/product",
        name:"product",
        component:()=>import('@/view/product/product.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/product/:type_title",
        name:"product",
        component:()=>import('@/view/product/product.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/news",
        name:"news",
        component:()=>import('@/view/news/news.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/video",
        name:"video",
        component:()=>import('@/view/video/video.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/recycle-free-tech",
        name:"recycle-free-tech",
        component:()=>import('@/view/free/free.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/news/newsDetial",
        name:"newsDetial",
        component:()=>import('@/view/news/newsDetial.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path:"/contact",
        name:"contact",
        component:()=>import('@/view/contact/contact.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path:"/product-detail/:title",
        name:"productDetial",
        component:()=>import('@/view/product/productDetial.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path:"/video/vr",
        name:"vr",
        component:()=>import('@/view/video/vr.vue'),
        meta: {
          keepAlive: false
        }
      }
    ]
  },
   {
     path:"/news",
        name:"news",
        component:()=>import('@/view/news/news.vue'),
        meta: {
          keepAlive: true
        }
  },{
     path:"/news/company-news",
        name:"company-news",
        component:()=>import('@/view/news/news.vue'),
        meta: {
          keepAlive: true
        }
  },{
     path:"/news/industry-news",
        name:"industry-news",
        component:()=>import('@/view/news/news.vue'),
        meta: {
          keepAlive: true
        }
  },
//   {
//     path: "/login",
//     name: "login",
//     component: () => import("@/view/login.vue"),
//   },
];

let router = new Router({
  routes, 
   mode: 'history',
});

export default router;
